import { clearElement } from "../core/utils/dom";
import type { Page } from "../pages/Page";
import { DocsPage } from "../pages/DocsPage";
import { DrawMapPage } from "../pages/DrawMapPage";
import { HomePage } from "../pages/HomePage";
import { ToolsPage } from "../pages/ToolsPage";
import { getCurrentRoute, ROUTES, type RouteId } from "./router";

export class App {
  private currentPage: Page | null = null;
  private content!: HTMLElement;

  mount(root: HTMLElement): void {
    root.innerHTML = `
      <header class="app-header">
        <a href="#viewer" class="brand">POC GIS</a>
        <nav class="nav" aria-label="Main navigation">
          ${ROUTES.map((route) => `<a href="${route.hash}" data-route="${route.id}">${route.label}</a>`).join("")}
        </nav>
      </header>
      <div id="app-content"></div>
    `;
    this.content = root.querySelector("#app-content") as HTMLElement;
    window.addEventListener("hashchange", () => this.renderRoute());
    this.renderRoute();
  }

  private renderRoute(): void {
    this.currentPage?.destroy?.();
    clearElement(this.content);

    const route = getCurrentRoute();
    this.highlightActiveRoute(route);
    this.currentPage = this.createPage(route);
    this.content.appendChild(this.currentPage.render());
  }

  private createPage(route: RouteId): Page {
    switch (route) {
      case "drawer":
        return new DrawMapPage();
      case "tools":
        return new ToolsPage();
      case "docs":
        return new DocsPage();
      case "viewer":
      default:
        return new HomePage();
    }
  }

  private highlightActiveRoute(route: RouteId): void {
    document.querySelectorAll<HTMLAnchorElement>("[data-route]").forEach((link) => {
      link.classList.toggle("active", link.dataset.route === route);
    });
  }
}
